// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"25825":"9ba942e337e052c44f5e","51231":"825acdfb2a89d874357c"}[chunkId] + ".css";
};